import { type FormTemplate } from '@wix/ambassador-forms-v1-form-template/types';
import { type Form, type FormField } from '@wix/ambassador-forms-v4-form/types';

function isDefined<T>(value: T): boolean {
  return !(value === null || value === undefined);
}

export function applyMultilineAddressSettings(
  form: Form | FormTemplate,
  settings?: Record<string, any>,
  multilineAddressValidation?: Record<string, any>,
): Form | FormTemplate {
  if (!settings || !multilineAddressValidation) {
    return form;
  }

  return {
    ...form,
    fields: (form.fields ?? []).map((field: FormField) => {
      const { show, ...rest } = settings[field.target!] || {};
      const { required } = multilineAddressValidation[field.target!] || {};

      return {
        ...field,
        view: {
          ...field.view,
          ...rest,
        },
        ...(isDefined(show) && { hidden: !show }),
        ...(isDefined(required) &&
          isDefined(field.validation) && {
            validation: {
              ...field.validation,
              required,
              // TODO: Fix type
            } as any,
          }),
      };
    }),
  };
}
